import React from "react"

import Icon from "~/components/atoms/Icon"
import Typography from "~/components/atoms/Typography"
import { NewGradJobDetail } from "~/entities/NewGradJob"

import * as Styled from "./styled"

type Props = {
  career: NewGradJobDetail["careers"][number]
}

export const CareerPathCard: React.VFC<Props> = ({ career }) => {
  return (
    <Styled.Card>
      <Styled.CardTop>
        <Typography type="SubHeading">{career.title}</Typography>
        <Styled.CardTopDescription>{career.description}</Styled.CardTopDescription>
      </Styled.CardTop>
      {career.steps.length > 0 && (
        <Styled.CardBottom>
          {career.steps.map(({ title, enrollment_period }, i) => (
            <Styled.CardItem key={i}>
              <Styled.CardItemIcon>
                <Icon type="Bag" size={24} />
              </Styled.CardItemIcon>
              <Styled.CardItemRight>
                <Styled.CardItemRightTitle>{title}</Styled.CardItemRightTitle>
                <Styled.CardItemRightSchedule>{enrollment_period}</Styled.CardItemRightSchedule>
              </Styled.CardItemRight>
            </Styled.CardItem>
          ))}
        </Styled.CardBottom>
      )}
    </Styled.Card>
  )
}
